var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-select',{attrs:{"error":_vm.error,"required":_vm.required,"value":_vm.internalValue,"name":"salutation","label":"salutation","options":_vm.options,"disabled":_vm.disabled},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }